import { InitFeatureParams } from '@/features/types'

import { getRoutes } from './routes'

/**
 * 定义报名路由
 *
 * @param param0 - 参数
 * @param param0.addRoutes - 路由参数
 * @return 路由定义
 */
export const initEnrollTask = ({ addRoutes }: InitFeatureParams) => {
  addRoutes(getRoutes())
}
